import { Box, ChevronLeft, ChevronRight } from 'lucide-react';
import { useState } from 'react';
import { cn } from '@/lib/utils';
import { ProductImage, type DisplayCrop } from './product-image';

export function CardCarousel({
	images,
	name,
}: {
	images?: Array<{
		url?: string | null;
		isPrimary?: boolean | null;
		crop?: DisplayCrop | null;
	}> | null;
	name: string;
}) {
	const sorted = [...(images ?? [])].sort((a, b) => (a.isPrimary ? -1 : b.isPrimary ? 1 : 0));
	const [idx, setIdx] = useState(0);
	const hasMultiple = sorted.length > 1;
	const current = sorted[idx];

	const prev = (e: React.MouseEvent) => {
		e.stopPropagation();
		setIdx((i) => (i > 0 ? i - 1 : sorted.length - 1));
	};
	const next = (e: React.MouseEvent) => {
		e.stopPropagation();
		setIdx((i) => (i < sorted.length - 1 ? i + 1 : 0));
	};

	if (!sorted.length || !current?.url) {
		return (
			<div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-media-well">
				<div className="flex h-10 w-10 items-center justify-center rounded-full border border-line-1 bg-surface-input text-text-4">
					<Box size={18} />
				</div>
				<span className="px-4 text-center text-xs text-text-4">No image</span>
			</div>
		);
	}

	return (
		<>
			<ProductImage image={current} alt={name} className="absolute inset-0 h-full w-full" />

			{hasMultiple && (
				<>
					<button
						onClick={prev}
						className="absolute left-1.5 top-1/2 z-10 flex h-6 w-6 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-black/50 text-white/70 opacity-0 backdrop-blur-sm transition-opacity group-hover:opacity-100 hover:bg-black/70 hover:text-white"
					>
						<ChevronLeft size={14} />
					</button>
					<button
						onClick={next}
						className="absolute right-1.5 top-1/2 z-10 flex h-6 w-6 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-black/50 text-white/70 opacity-0 backdrop-blur-sm transition-opacity group-hover:opacity-100 hover:bg-black/70 hover:text-white"
					>
						<ChevronRight size={14} />
					</button>

					<div className="absolute bottom-2 left-1/2 z-10 flex -translate-x-1/2 gap-1">
						{sorted.map((_, i) => (
							<button
								key={i}
								onClick={(e) => {
									e.stopPropagation();
									setIdx(i);
								}}
								className={cn(
									'h-1.5 rounded-full transition-all',
									i === idx
										? 'w-3 bg-white'
										: 'w-1.5 bg-white/40 hover:bg-white/60'
								)}
							/>
						))}
					</div>
				</>
			)}
		</>
	);
}
